import React from 'react';
import ReactDOM from 'react-dom';
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';
import CheckoutForm from './Checkout';
import CheckoutForm2 from './Checkout2';

const client = new ApolloClient({
    uri: 'https://plus.dutchie.com/plus/2021-07/graphql',
    cache: new InMemoryCache(),
    headers: {
        Authorization: 'Bearer public-eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJBUEktQ0xJRU5UIiwiZXhwIjozMzIwMjk5MDQ4MCwiaWF0IjoxNjQ2MDgxNjgwLCJpc3MiOiJodHRwczovL2R1dGNoaWUuY29tIiwianRpIjoiNzA1YjdiMjgtNTM4ZS00NmNhLTgwYjUtMGJiY2NiNGJmN2VlIiwiZW50ZXJwcmlzZV9pZCI6IjM3NTI5MDRhLWZiNzItNDI4ZS05OTI0LTk4NzE0M2YxZGFlYSIsInV1aWQiOiJmMWY2NzhlMC02MWNjLTQ3MDktODYyNC1jNTM0NWZhZWQ5ZGEifQ.m8SonI4lsdWwtMTBP35c78vNYQoy2tX2sEmknfBIpeg',
    },
});

const retailerId = window.retailerid;
const checkoutId = window.checkoutid;

// Check localStorage for 'testmode' and conditionally render the appropriate form
const isTestMode = false;

ReactDOM.render(
    <ApolloProvider client={client}>
        <div>
            {isTestMode ? (
                <CheckoutForm2 retailerId={retailerId} checkoutId={checkoutId} />
            ) : (
                <CheckoutForm retailerId={retailerId} checkoutId={checkoutId} />
            )}
        </div>
    </ApolloProvider>,
    document.getElementById('root')
);
